import { SupportedApplication } from "@shopliftr/common-js/shared";
import packageInfo from "apps/smart/package.json";
import { IAppConfig } from "../app/common/interfaces/app-config";

/**
 * Invariant configuration shared by every SMART environment.
 *
 * Environment-specific settings (URLs, telemetry, production/staging flags) are
 * declared explicitly in each concrete environment file so that every config
 * states its own effective settings. Login credentials are intentionally NOT
 * declared here — they are inlined per environment so they are never bundled
 * into builds that should not ship them (e.g. production).
 */
export const environment: Pick<
    IAppConfig,
    "appVersion" | "appName" | "authentication" | "appLinks" | "timezone"
> = {
    appVersion: packageInfo.version,
    appName: SupportedApplication.Smart,
    authentication: {
        logoUrl: "/assets/images/logo-black-shopliftr.svg",
        heading: "SMART Designer"
    },
    appLinks: [{
        title: "Admin",
        url: "https://dev.admin.mygrocerydeals.com",
        icon: "queue_play_next",
        roles: ["partner-admin"]
    }],
    timezone: "America/Chicago"
};
